
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog/parenting-tsurai",
      function () {
        return require("private-next-pages/blog/parenting-tsurai.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/blog/parenting-tsurai"])
      });
    }
  